import { render, staticRenderFns } from "./VendorEditTabVendor.vue?vue&type=template&id=18967df6"
import script from "./VendorEditTabVendor.vue?vue&type=script&lang=js"
export * from "./VendorEditTabVendor.vue?vue&type=script&lang=js"
import style0 from "./VendorEditTabVendor.vue?vue&type=style&index=0&id=18967df6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports